import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageContextProvider } from '../../store/page-context';
import { ApplicationsList } from '../../components/application/ApplicationsList';
import { PageLink, PageTitle } from '../../layout/core';

export const ApplicationsPage = (): JSX.Element => {
    const { t } = useTranslation();

    const merchantsBreadCrumbs: Array<PageLink> = [
        {
            title: t('MENU.ACCOUNTS'),
            path: '/accounts/accounts',
            isSeparator: false,
            isActive: false
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false
        }
    ];
    return (
        <PageContextProvider page="merchants/applications">
            <>
                <PageTitle breadcrumbs={merchantsBreadCrumbs}>{t('MERCHANT_PAGE.APPLICATION_LIST')}</PageTitle>
                <ApplicationsList />
            </>
        </PageContextProvider>
    );
};
